module.exports = __webpack_public_path__ + "img/racoon-top.792cccd5.png";